import Vue from 'vue'

let that = new Vue();
let jq = $;
export default {

  /**
   * 常量
   * @Author
   * @Date
   */
  constant: {
    /**
     * 访问ip
     */
    ip:null,

    timer:function () {

    },

    db: {
      /**
       * 屏幕录制
       * @Author
       * @Date
       */
      screenRecording: {
        dbName: "XB_SCREEN_RECORDING",
        tables: {
          screen: "screen"
        }
      }
    },

    clientDomain: "xbyf.xiaobaibao.com" // 正式环境
    // clientDomain: "xbyftest.xiaobaibao.com" // 测试环境
    // clientDomain: 'http://192.168.0.104:8842'       // 本地环境
    // clientDomain: 'localhost:8080'       // 本地环境
  },

  /**
   * 屏幕录制记录自动报送
   * @Author
   * @Date
   */
  screenRecordSubmitted: function (orderId) {
    let _that = this;

    // clientDomain默认正式环境才开启回溯录制，其他环境测试完记得更改回去
    if(window.location.host.indexOf(_that.constant.clientDomain) === -1) return;
    try {
      that.loki;
    } catch (e) {
      setTimeout(_that.screenRecordSubmitted(orderId), 1000);
      return;
    }
    try {
      const {database, collection} = this.getScreenRecordDB();
      window.XB_SCREEN_DB = {database, collection};
      let retryCount = 0;
      const retry = function () {
        retryCount++;
        if (retryCount < 3) {
          loop();
          return;
        }
        throw "屏幕录制报送失败, 已中断轮巡！";
      };

      const loop = function () {
        if( !_that.isValidObj(_that.getUrlParam("eventLogToken")) ){
          clearInterval(_that.constant.timer);
          _that.constant.timer = null;
          window.screenRecording = false;
          return;
        }

        let datums = collection.find({});
        if (datums.length <= 0) {
          // -- 问题点(可能执行异常)
          setTimeout(loop, 2000);
          return;
        }

        /* 小杰改造（未使用） */
        /*datums.forEach(item => {
          let map = {};
          map.data = item.data;
          map.recordToken = item.recordToken;
          // -- 此处需传订单号;
          item.orderId = orderId;
          item.ip = _that.constant.ip;
          item.data = JSON.stringify(map);
        });
        that.axios.post(_that.constant.clientDomain + '/management/thirdTraceScreenRecord/save', {
          datums:datums
        }).then((response) => {
          const {success} = response.data;
          if (success) {
            // -- 问题点(可能执行异常)
            datums.forEach(item => {
              item.data = JSON.parse(JSON.parse(item.data).data);
            });
            collection.removeBatch(datums);
            database.save();
            setTimeout(loop, 3000);
          } else {
            retry();
          }
        }).catch((response) => {
          retry();
        });*/

        // 现代财产保险（中国）有限公司 - 国内贸易信用险 - 保存orderId特殊处理
        if (window.location.pathname == '/domesticTradeCredit/orderDetail' && !_that.isValidObj(orderId)){
          location.reload();
        }

        /* 原H5方法 */
        datums.forEach(item => {
          let map = {};
          map.data = item.data;
          map.recordToken = item.recordToken;
          item.data = JSON.stringify(map);
          item.orderId = orderId;
          // item.ip = _that.constant.ip;
        });

        // return;
        // console.log(datums, JSON.stringify(datums));
        that.axios.post('/management/traceeventscreenrecord/save',{
          datums: datums,
        }).then((response) => {
          const {success} = response.data;
          if (success) {
            // -- 问题点(可能执行异常)
            datums.forEach(item => {
              item.data = JSON.parse(JSON.parse(item.data).data);
            });
            collection.removeBatch(datums);
            database.save();
            setTimeout(loop, 3000);
          } else {
            retry();
          }
        }).catch((response) => {
          retry();
        });
      };
      loop();
    } catch (e) {
      console.error(e);
    }
  },

  /**
   * 判断object是否为空, [true]: 不为空, [false]: 为空

   */
  isValidObj: function (obj) {
    if (obj == null || (obj + '') === '' || (obj + '').length <= 0 || obj === 'undefined') {
      return false;
    }
    return true;
  },

  /**
   * Image标签的Src, 所有标签的BackgroundImage 转换成Base64
   * @Author
   * @Date
   */
  imgEleSrc2base64: function () {
    try {
      jq("img").each((index, element) => {
        //console.log($(element).attr('src') + ' =>');
        const base64 = transferToBase64(element);
        //console.log($(element).attr('class') + ' =>');
        //console.log(base64);
        if (base64 == null || base64 == 'data:,') return;
        $(element).attr("src", base64);
      });
      jq("*").each((i, e) => {
        let url;
        try {
          const that = jq(e);
          const backgroundImage = "background-image";
          url = that.css(backgroundImage);
          if (!url || url == "none" || url.includes("linear-gradient")) return;
          url = url.split('("')[1].split('")')[0];
          const tempImg = document.createElement("img");
          tempImg.src = url;
          tempImg.onload = function () {
            const base64 = transferToBase64(tempImg);
            if (base64 == null || base64 == 'data:,') return;
            that.css(backgroundImage, `url("${base64}")`);
          }
        } catch (e) {
          console.log(e);
        }
      });
    } catch (e) {
      console.error(e);
    }

    function transferToBase64(image) {
      try {
        let {src, height, width} = image;
        height = height * 2;
        width = width * 2;
        if (src.indexOf("aliyuncs.com") != -1 || src.startsWith("data:")) return;
        const canvas = document.createElement("canvas");
        canvas.height = height;
        canvas.width = width;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, width, height);
        return canvas.toDataURL();
      } catch (e) {
        console.error(e);
        return null;
      }
    }
  },

  /**
   * 获取UUID值
   * @returns {string}
   */
  uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },

  /**
   * 屏幕录制  ``页面加载只能调用一次
   * @Author
   * @Date
   */
  screenRecording: function (eventLogToken) {
    let _that = this;
    try {
      if (!window.XB_SCREEN_DB) {
        setTimeout(function () {
          _that.screenRecording(eventLogToken);
        }, 600);
        return;
      }
      try {
        // if(ShawHandler.checkIsLocal()) throw '本地不做屏幕录制！';
        if (window.screenRecording) throw '已经在录制中！';
        if (!that.rrweb) throw '未引入屏幕录制库 RRWeb！';
        if (!this.isValidObj(eventLogToken)) throw '事件Token不能为空！';
      } catch (e) {
        throw `【屏幕录制】 ${e}`;
      }
      this.imgEleSrc2base64();
      const {database, collection} = window.XB_SCREEN_DB;
      that.rrweb.record({
        emit(event) {
          try {
            event = {
              ...event,
              recordToken: _that.uuid(),
              requestToken: eventLogToken,
              data: JSON.stringify(event.data)
            };
            collection.insert(event);
          } catch (e) {
          }
        }
      });
      _that.constant.timer = setInterval(function () {
        if (collection.data.length <= 0) return;
        try {
          database.save();
        } catch (e) {
        }
      }, 600);
      window.screenRecording = true;
    } catch (e) {
      console.error(e);
    }
  },

  /**
   * 获取屏幕录制的数据库、数据表
   * @Author
   * @Date
   */
  getScreenRecordDB: function () {
    const {dbName, tables: {screen}} = this.constant.db.screenRecording;
    const tableName = screen;
    const database = new that.loki(dbName);
    let collection = database.getCollection(tableName);
    if (collection == null) {
      collection = database.addCollection(tableName);
    }
    return {database, collection};
  },

  /**
   * 获取地址栏参数
   * @Author 肖家添
   * @Date 2019/8/29 9:57
   */
  getUrlParam(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.href.toString().substring(window.location.href.indexOf("?")+1, window.location.href.length).match(reg);
    if(r != null) return unescape(r[2]);

    return null;
  },

  /**
   * 当前url追加参数;
   * @param uri
   * @param key
   * @param value
   * @returns {string|*}
   */
  updateQueryStringParameter(uri, key, value) {
    if(!value) {
      return uri;
    }
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  },

  /**
   * 获取eventLogToken
   * @param orderId
   * @param appId
   * @param key
   */
  getEventLogToken(orderId,appId,key){
    that.axios.post(this.constant.clientDomain + '/management/thirdTraceScreenRecord/getRequestToken', {
      appId:appId,
      domain: window.location.href,
      key: key
    }).then((response) => {
      const {success, msg} = response.data;
      if (success) {
        let json = JSON.parse(msg);
        let newUrl = this.updateQueryStringParameter(window.location.href,"eventLogToken", json.requestToken);
        window.history.replaceState('','',newUrl);
        this.screenRecordSubmitted(orderId);
        this.screenRecording(json.requestToken);
      }
    });
  },

  startLoad(orderId,appId,key) {
    // return;
    let _that = this;
    try {
      document.querySelector('meta[name="base-app-close-hook"]').getAttribute("content");
    } catch (e) {
      hook();
    }

    function hook() {
      try {
        if( window.location.href.indexOf("eventLogToken") !== -1 ){
          onload();
        }

        /*$.getJSON("https://api.ipify.org/?format=json", function (data) {
          _that.constant.ip = data.ip;

        });*/
      } catch (e) {
        window.setTimeout(hook, 1500);
      }
    }

    // Warning: please use try catch to capture inside the method!
    function onload() {
      try {
        //-- 屏幕录制记录报送
        _that.screenRecordSubmitted(orderId);
        let eventLogToken = decodeURIComponent(encodeURIComponent(_that.getUrlParam("eventLogToken")).replace(new RegExp("%20","gm"),"%2B"));
        _that.screenRecording(eventLogToken);
      } catch (e) {
        console.error(e);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/tool/milibao/screenRecBase.js